export enum ProfileTableNamesEnum {
  NextOfKin = 'NextOfKin',
  CompetenceUser = 'CompetenceUser',
  ReadReceipts = 'ReadReceipts',
}
